/**
 * Collection filter sidebar modal (tablet/mobile).
 * Moves the single [data-collection-filter-sidebar] node into the modal when opened,
 * and back into .main-collection-with-sidebar when closed or on resize to desktop.
 *
 * Deep-link ?filter= tags are applied on page load by collection-filter-sidebar.js
 * (checkbox + toolbar state before this modal runs).
 */
(function () {
  const SIDEBAR_SELECTOR = "[data-collection-filter-sidebar]";
  const MODAL_ID = "mobile-collection-filters-modal";
  const SLOT_ID = "mobile-collection-filters-sidebar-slot";
  const LAYOUT_PARENT_SELECTOR = ".main-collection-with-sidebar";
  const GRID_WRAPPER_SELECTOR = ".main-collection-product-grid-wrapper";
  const DESKTOP_BREAKPOINT = 1024;

  function throttle(fn, limit) {
    var inThrottle;
    return function () {
      if (!inThrottle) {
        fn.apply(this, arguments);
        inThrottle = true;
        setTimeout(function () {
          inThrottle = false;
        }, limit);
      }
    };
  }

  function moveSidebarToModal() {
    var sidebar = document.querySelector(SIDEBAR_SELECTOR);
    var slot = document.getElementById(SLOT_ID);
    if (!sidebar || !slot) return;
    if (sidebar.parentNode === slot) return;
    slot.appendChild(sidebar);
  }

  function moveSidebarToLayout() {
    var sidebar = document.querySelector(SIDEBAR_SELECTOR);
    var layout = document.querySelector(LAYOUT_PARENT_SELECTOR);
    var gridWrapper = document.querySelector(GRID_WRAPPER_SELECTOR);
    if (!sidebar || !layout || !gridWrapper) return;
    if (sidebar.parentNode === layout) return;
    layout.insertBefore(sidebar, gridWrapper);
  }

  function init() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    function resetModalState() {
      modal.classList.remove("active");
      modal.style.display = "none";
      document.body.classList.remove("modal-opened");
      document.body.style.overflow = "";
    }

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        resetModalState();
        moveSidebarToLayout();
      }
    });

    window.addEventListener("pagehide", function () {
      resetModalState();
      moveSidebarToLayout();
    });

    function closeModalOnResize() {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        if (modal.classList.contains("active")) {
          if (typeof modal.hide === "function") {
            modal.hide();
          } else {
            resetModalState();
          }
          moveSidebarToLayout();
        }
      }
    }

    window.addEventListener("resize", throttle(closeModalOnResize, 150));

    var closeElements = modal.querySelectorAll("[data-js-close]");
    closeElements.forEach(function (el) {
      el.addEventListener("click", function () {
        if (typeof modal.hide === "function") {
          modal.hide();
        } else {
          resetModalState();
        }
      });
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          if (modal.classList.contains("active")) {
            moveSidebarToModal();
          } else {
            moveSidebarToLayout();
          }
        }
      });
    });

    observer.observe(modal, { attributes: true, attributeFilter: ["class"] });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
